<div class="cpcontent" [hidden]="isAuthenticatedWithFirebase">
    Signin with Google to access the Firebase database
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1>Virtual Exercise Firebase Database</h1>
    <div class="row">
        <div class="col-md-6">
            <div style="display:inline-block;max-width:200px"><sa-select [(Id)]="worldkey" [title]="'Worlds'"
                    [options]="worldskeys"></sa-select></div>
            <button class="btn btn-primary" (click)="selectWorld()" style="margin-left:20px">Select World</button>
            <br><br><br>
            <b>Add a new world by copying from an existing one.</b><br>
            The new name has to be unique.<br>
            <div style="display:inline-block;max-width:200px"><sa-select [(Id)]="worldkey" [title]="'Worlds'"
                    [options]="worldskeys"></sa-select></div>
            <button class="btn btn-primary" (click)="addWorld()" style="margin-left:20px">Copy World to</button>
            <div style="display:inline-block;max-width:200px;margin-left:20px">
                <sa-input-text [(text)]="newWorldName" [title]="'new name' "></sa-input-text>
            </div>
            <br>
            <br>
            <b>Remove players from scenario</b>
            <button style="margin-left:20px" class="btn btn-primary btn-sm" (click)="getData()"
                style="margin-left:20px">Refresh</button>
            <button style="margin-left:20px" class="btn btn-primary btn-sm" (click)="showPlayers = !showPlayers">toggle
                player details</button>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Scenario</th>
                        <th>Players</th>
                        <th>Remove</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let p of scenarios">
                        <td>{{p.name}}</td>
                        <td>
                            {{getNumberOfKeys(p.players)}}

                            <br>
                            <div *ngIf="p.players && showPlayers">
                                <div *ngFor="let play of collectionToArray( p.players)">
                                    {{play.name}} with loading time: {{play.sceneLoadingTime | number:'1.0-0' }} ms
                                </div>
                            </div>
                        </td>
                        <td><button class="btn btn-warning btn-sm" (click)="removePlayerFromScenario(p)">Remove</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-6">
            <canvas id="canvas" #canvas width="600" height="600" style="border: 1px solid #000;"></canvas>
            <br>
            Rough outline of position of components
        </div>
    </div>
    <br>

    <br>
    <h5 style="display:inline-block">Components for World</h5>
    <button *ngIf="world != null" class="btn btn-primary" (click)="addComponent()" style="float:right">Add
        component</button>

    <table class="table tablebordered">
        <thead>
            <tr>
                <th>edit</th>
                <th>Name "+.glb"<i class="bi bi-arrow-down-up" style="font-size: 1.0em;"
                        (click)="sortGeneric(components,'name',sortArray)"></i> </th>

                <!-- <th>File<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(components,'file',sortArray)"></i></th> -->
                <th>Sensors?</th>
                <th>posX<i class="bi bi-arrow-down-up" style="font-size: 1.0em;"
                        (click)="sortGeneric(components,'posX',sortArray)"></i></th>
                <th>posY<i class="bi bi-arrow-down-up" style="font-size: 1.0em;"
                        (click)="sortGeneric(components,'posY',sortArray)"></i></th>
                <th>posZ<i class="bi bi-arrow-down-up" style="font-size: 1.0em;"
                        (click)="sortGeneric(components,'posZ',sortArray)"></i></th>
                <th>rotX</th>
                <th>rotY</th>
                <th>rotZ</th>
                <th>scale<i class="bi bi-arrow-down-up" style="font-size: 1.0em;"
                        (click)="sortGeneric(components,'scale',sortArray)"></i></th>
                <th>check Collisions</th>
                <th>Delete</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let c of components">
                <td><button class="btn btn-primary btn-sm" (click)="editComponent(c)">Edit</button></td>

                <td>{{c?.name}}</td>
                <!-- <td>{{c?.file}}</td> -->
                <td [ngStyle]="{'background-color': c.sensors ? 'orange' : 'none'}">
                    {{(c?.sensors?.length > 0)? "Hot: " : ""}}
                </td>
                <td>{{c?.posX}}</td>
                <td>{{c?.posY}}</td>
                <td>{{c?.posZ}}</td>
                <td>{{c?.rotX}}</td>
                <td>{{c?.rotY}}</td>
                <td>{{c?.rotZ}}</td>
                <td>{{c?.scale}}</td>
                <td>{{c?.checkCollisions}}</td>
                <td><button class="btn btn-warning btn-sm" (click)="deleteComponent(c)">Delete</button></td>
            </tr>
        </tbody>
    </table>
    <hr>
    <button *ngIf="world != null" class="btn btn-primary" (click)="updateWorld()">Update</button><br>
    <div *ngIf="world != null" class="row">
        <div class="col-md-2">
            <h5>Skybox</h5>
            <sa-input-text [(text)]="skybox.reflectionTexture" [title]="'reflectionTexture' "></sa-input-text>
            <sa-input-boolean [(checked)]="skybox.backFaceCulling" [title]="'backFaceCulling' "></sa-input-boolean>
            <sa-input-boolean [(checked)]="skybox.disableLighting" [title]="'disableLighting' "></sa-input-boolean>
            <sa-input-boolean [(checked)]="skybox.infiniteDistance" [title]="'infiniteDistance' "></sa-input-boolean>
            <sa-input-number [(text)]="skybox.size" [title]="'size' "></sa-input-number>
        </div>
        <div class="col-md-2">
            <h5>Walls East</h5>
            <sa-input-text [(text)]="walls.east.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
            <sa-input-number [(text)]="walls.east.height" [title]="'height' "></sa-input-number>
            <sa-input-number [(text)]="walls.east.width" [title]="'width' "></sa-input-number>
            <sa-input-number [(text)]="walls.east.x" [title]="'x' "></sa-input-number>
            <sa-input-number [(text)]="walls.east.y" [title]="'y' "></sa-input-number>
            <sa-input-number [(text)]="walls.east.z" [title]="'z' "></sa-input-number>


        </div>
        <div class="col-md-2">
            <h5>Walls North</h5>
            <sa-input-text [(text)]="walls.north.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
            <sa-input-number [(text)]="walls.north.height" [title]="'height' "></sa-input-number>
            <sa-input-number [(text)]="walls.north.width" [title]="'width' "></sa-input-number>
            <sa-input-number [(text)]="walls.north.x" [title]="'x' "></sa-input-number>
            <sa-input-number [(text)]="walls.north.y" [title]="'y' "></sa-input-number>
            <sa-input-number [(text)]="walls.north.z" [title]="'z' "></sa-input-number>
        </div>
        <div class="col-md-2">
            <h5>Walls West</h5>
            <sa-input-text [(text)]="walls.west.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
            <sa-input-number [(text)]="walls.west.height" [title]="'height' "></sa-input-number>
            <sa-input-number [(text)]="walls.west.width" [title]="'width' "></sa-input-number>
            <sa-input-number [(text)]="walls.west.x" [title]="'x' "></sa-input-number>
            <sa-input-number [(text)]="walls.west.y" [title]="'y' "></sa-input-number>
            <sa-input-number [(text)]="walls.west.z" [title]="'z' "></sa-input-number>
        </div>
        <div class="col-md-2">
            <h5>Walls South</h5>
            <sa-input-text [(text)]="walls.south.diffuseTexture" [title]="'diffuseTexture' "></sa-input-text>
            <sa-input-number [(text)]="walls.south.height" [title]="'height' "></sa-input-number>
            <sa-input-number [(text)]="walls.south.width" [title]="'width' "></sa-input-number>
            <sa-input-number [(text)]="walls.south.x" [title]="'x' "></sa-input-number>
            <sa-input-number [(text)]="walls.south.y" [title]="'y' "></sa-input-number>
            <sa-input-number [(text)]="walls.south.z" [title]="'z' "></sa-input-number>
        </div>
        <div class="col-md-2">
            <h5>Ground</h5>
            <sa-input-text [(text)]="ground.file" [title]="'file' "></sa-input-text>
            <sa-input-number [(text)]="ground.height" [title]="'height' "></sa-input-number>
            <sa-input-number [(text)]="ground.subdivisions" [title]="'subdivisions' "></sa-input-number>
            <sa-input-number [(text)]="ground.width" [title]="'width' "></sa-input-number>
        </div>
    </div>
    <button *ngIf="world != null" class="btn btn-primary" (click)="updateWorld()">Update</button><br>
    <hr>
    <h5>World JSON</h5>
    <pre>{{world | json }}</pre>
    <!-- <hr>
    <pre>
    {{worlds | json}}</pre> -->
</div>

<div *ngIf="showModal" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Component "{{component.name}}"</h5>


        <div class="container mt-5">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="header-tab" data-bs-toggle="tab" href="#header" role="tab"
                        aria-controls="header" aria-selected="true">Header</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="clone-tab" data-bs-toggle="tab" href="#clone" role="tab"
                        aria-controls="clone" aria-selected="false">
                        Clone ({{component.clones? component.clones.length : 0}})
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="sensor-tab" data-bs-toggle="tab" href="#sensor" role="tab"
                        aria-controls="sensor" aria-selected="false">
                        Sensor ({{component.sensors? component.sensors.length : 0}})
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="sensor-tab" data-bs-toggle="tab" href="#raw" role="tab" aria-controls="raw"
                        aria-selected="false">JSON</a>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="header" role="tabpanel" aria-labelledby="header-tab">
                    <sa-input-text [(text)]="component.name" [title]="'name + filename.glb' "
                        (hasChanged)="nameHasChanged()"></sa-input-text>
                    <!-- <sa-input-text [(text)]="component.file" [title]="'file' "></sa-input-text> -->
                    <div class="row">
                        <div class="col-md-4"><sa-input-number [(text)]="component.posX"
                                [title]="'posX' "></sa-input-number></div>
                        <div class="col-md-4"><sa-input-number [(text)]="component.posY"
                                [title]="'posY' "></sa-input-number></div>
                        <div class="col-md-4"> <sa-input-number [(text)]="component.posZ"
                                [title]="'posZ' "></sa-input-number></div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><sa-input-number [(text)]="component.rotX"
                                [title]="'rotX' "></sa-input-number></div>
                        <div class="col-md-4"><sa-input-number [(text)]="component.rotY"
                                [title]="'rotY' "></sa-input-number></div>
                        <div class="col-md-4"> <sa-input-number [(text)]="component.rotZ"
                                [title]="'rotZ' "></sa-input-number></div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"> <sa-input-number [(text)]="component.scale"
                                [title]="'scale' "></sa-input-number></div>
                        <div class="col-md-4"><sa-input-boolean [(checked)]="component.checkCollisions"
                                [title]="'checkCollisions' "></sa-input-boolean></div>

                    </div>

                </div>
                <div class="tab-pane fade" id="clone" role="tabpanel" aria-labelledby="clone-tab">
                    <button class="btn btn-primary" (click)="addClone()">Add Clone</button>
                    <div *ngIf="component['clones'] != null">
                        <table class="table tablebordered">
                            <thead>
                                <tr>
                                    <th>posX</th>
                                    <th>posY</th>
                                    <th>posZ</th>
                                    <th>rotX</th>
                                    <th>rotY</th>
                                    <th>rotZ</th>
                                    <th>Delete</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let c of component.clones">
                                    <td><sa-input-number [(text)]="c.posX" [title]="'posX' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.posY" [title]="'posY' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.posZ" [title]="'posZ' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.rotX" [title]="'rotX' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.rotY" [title]="'rotY' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="c.rotZ" [title]="'rotZ' "></sa-input-number></td>
                                    <td><button class="btn btn-warning btn-sm" (click)="deleteClone(c)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="tab-pane fade" id="sensor" role="tabpanel" aria-labelledby="sensor-tab">
                    <button class="btn btn-primary" (click)="addSensor()">Add Sensor</button>
                    <div *ngIf="component['sensors'] != null">
                        <!-- create a table equivalent to clones with columns name, units, min_distance, max_distance, max_value-->
                        <table class="table tablebordered">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Units</th>
                                    <th>Min Distance</th>
                                    <th>Max Distance</th>
                                    <th>Max Value</th>
                                    <th>Threshold/th>
                                    <th>Delete</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let s of component.sensors">
                                    <td><sa-input-text [(text)]="s.name" [title]="'name' "></sa-input-text></td>
                                    <td><sa-input-text [(text)]="s.units" [title]="'units' "></sa-input-text></td>
                                    <td><sa-input-number [(text)]="s.min_distance"
                                            [title]="'min_distance' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="s.max_distance"
                                            [title]="'max_distance' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="s.max_value"
                                            [title]="'max_value' "></sa-input-number></td>
                                    <td><sa-input-number [(text)]="s.threshold"
                                            [title]="'Threshold' "></sa-input-number></td>
                                    <td><button class="btn btn-warning btn-sm" (click)="deleteSensor(s)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>


                </div>
                <div class="tab-pane fade" id="raw" role="tabpanel" aria-labelledby="sensor-tab">
                    <!-- create a scrollable div with the heght of the container -->
                    <div style="height: 300px; overflow-y: scroll; overflow-x: hidden;">
                        <pre>{{component | json }}</pre>
                    </div>
                </div>
            </div>
        </div>





        <!-- {{component | json}} -->
        <br>
        <button class="btn btn-primary" (click)="updateWorld()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showModal = false">Close Modal</button>
    </div>
</div>